import React from 'react';
import styled from 'styled-components';
import ExclamationCircleIcon from '@ad-scripts/presentation/components/lib/icons/exclamation_circle_icon';

const AddEmailError: React.FC = () => {
  return (
    <ErrorContainer>
      <StyledErrorIcon />
      <ErrorContent>
        <ErrorText>
          The domain is already registered with another email service provider.{' '}
          <a
            href="https://help.gladly.com/product-docs/pages/en/contact-gladly-support-team"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Gladly Support
          </a>
          .
        </ErrorText>
      </ErrorContent>
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  margin-top: 8px;
  background-color: ${p => p.theme.colors.red100};
  border: 1px solid ${p => p.theme.colors.red200};
  border-radius: ${p => p.theme.borderRadius.default};
`;

const StyledErrorIcon = styled(ExclamationCircleIcon)`
  color: ${p => p.theme.colors.red500};
  height: ${p => p.theme.iconSize.xsmall};
  width: ${p => p.theme.iconSize.xsmall};

  svg {
    fill: ${p => p.theme.colors.red500} !important;
  }

  path {
    fill: ${p => p.theme.colors.red500} !important;
  }
`;

const ErrorContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ErrorText = styled.span`
  color: ${p => p.theme.colors.gray900};
  font-size: 14px;
  line-height: 1.4;
`;

export default AddEmailError;
